import React from 'react';
import credit_card_icon from 'assets/credit_card_green.svg';
import green_info_icon from 'assets/green_info_2.svg';
import shield_icon from 'assets/green_shield_2.svg';
import styled from 'styled-components';

const SecurityInfo = () => {
  return (
    <SecurityInfoWrapper>
      <SecurityItem>
        <Icon src={shield_icon} />
        <SecurityText>All payments are secure. EroPlay.ai does not gain access to your payment data. All information is transmitted via secure communication channels</SecurityText>
      </SecurityItem>
      <SecurityItem>
        <Icon src={green_info_icon} />
        <SecurityText>The payment will go to "SIA ChatMist" and will be called "Premium chat features" in your bank's interface</SecurityText>
      </SecurityItem>
      <SecurityItem>
        <Icon src={credit_card_icon} />
        <SecurityText>Google Pay, Apple Pay, VISA, MasterCard, PayPal</SecurityText>
      </SecurityItem>
    </SecurityInfoWrapper>
  );
};

const SecurityInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 8px;

  @media (max-width: 430px) {
    padding-bottom: 24px;
  }

  @media (max-width: 375px) {
    gap: 8px;
    margin-top: 4px;
    padding-bottom: 16px;
  }
`;

const Icon = styled.img<{ src: string }>`
  width: 14px;
  height: fit-content;
`;

const SecurityItem = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  color: rgba(255, 255, 255, 0.7);

  @media (max-width: 375px) {
    gap: 6px;
  }
`;

const SecurityText = styled.p`
  font-family: Nunito Sans;
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
  letter-spacing: 0%;
  color: rgba(255, 255, 255, 0.7);
  margin: 0;
`;

export default SecurityInfo; 